import type { Spacing } from '@iheartjane/reefer';
import { CheckboxField, Flex, Typography } from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';

import type { FilterSelectItem } from '@jane/search/types';

import { useKioskSpacing } from '../../../hooks';

export interface FilterCheckboxProps {
  checkboxSpacing?: Spacing;
  checked: boolean;
  disabled?: boolean;
  item: FilterSelectItem;
  onChange: (checked: boolean) => void;
  showCount?: boolean;
}

export const FilterCheckbox = ({
  checkboxSpacing = 16,
  checked,
  disabled,
  item,
  onChange,
  showCount = true,
}: FilterCheckboxProps) => {
  const { getKioskSpacing } = useKioskSpacing();
  return (
    <Flex
      as="label"
      alignItems="center"
      flexDirection="row"
      grow={1}
      py={getKioskSpacing(16, 12)}
    >
      <CheckboxField
        checked={checked}
        disabled={disabled}
        label={item.label}
        labelHidden
        name={item.value.toString()}
        onChange={onChange}
      />
      <Flex grow={1} pl={checkboxSpacing} justifyContent="space-between">
        <Typography color={disabled ? 'grays-light' : 'grays-mid'}>
          {item.label}
        </Typography>
        {showCount && (
          <Typography color="grays-mid">
            {pluralize({ noun: 'Product', number: item.count })}
          </Typography>
        )}
      </Flex>
    </Flex>
  );
};
